module.exports = __webpack_public_path__ + "img/111.35feb591.png";